import { useTranslation, useLogout, useGetIdentity, useOne, useList } from "@refinedev/core";
import { useGoogleConnect } from "hooks/google/useGoogleConnect";
import { useGoogleIsAuthenticated } from "hooks/google/useGoogleAuthenticated";
import { IAuthUser } from "@auth/firebase/interfaces";
import { Auth_Users, Invoice } from "@graphql/schema.types";
import { ConfigDashboardLayout } from "./layout";
export const ConfigProfessional = () => {
    const { translate } = useTranslation();
    const { mutate: logout } = useLogout();
    const [connectGoogleHandler] = useGoogleConnect()
    const { data: googleAuth } = useGoogleIsAuthenticated()
    const { data: identity } = useGetIdentity<IAuthUser>();
    // logger.debug(identity)

    const { data } = useOne<Auth_Users>({
        resource: "auth_users",
        id: identity?.user_id,
        meta: {
            fields: [
                'id',
                'uid',
                'display_name',
                'first_name',
                'other_names',
                'surname',
                'second_surname',
                'email',
                'phone_number',
                { 'professional': [{ 'membership': ['name'] }] }
            ],
        }
    });

    const user = data?.data;
    // logger.debug("user: ", user);

    const composeName = user ? [user.first_name, user.other_names, user.surname, user.second_surname].filter(e => !!e).join(" ") : ""
    const fullName = composeName || user?.display_name;
    const membership = user?.professional?.membership?.name || 'N/A';

    const { data: dataInvoice } = useList<Invoice>({
        resource: "invoice",
        sorters: [
            {
                field: 'updated_at',
                order: 'desc',
            },
        ],
        meta: {
            fields: [
                'id',
                'amount',
            ],
        }
    });

    // logger.debug("dataInvoice", dataInvoice, isLoadingInvoice);

    return <ConfigDashboardLayout
        user={user}
        identity={identity}
        planOrMembershipLabel={translate('page.config.membership')}
        planOrMembershipValue={membership}
        balance={dataInvoice?.data?.[0]?.amount ?? '-'}
        invoices={(dataInvoice?.data as any) ?? []}
        googleAuthenticated={googleAuth?.authenticated ?? false}
        onGoogleConnect={connectGoogleHandler as () => void}
        onLogout={logout as () => void}
        fullName={fullName ?? ''}
    />
}
